(function () {
	'use strict';

	angular.module('dcApp').directive('dbFilter', [
		'$parse',
		function ($parse) {
			var controller = [
				'$scope',
				'$rootScope',
				'TypeEntiteService',
				'toaster',
				'$sce',
				'$timeout',
				'gettextCatalog',
				'GrammarUtils',
				function (
					$scope,
					$rootScope,
					TypeEntiteService,
					toaster,
					$sce,
					$timeout,
					gettextCatalog,
					GrammarUtils
				) {
					var vm = this;
					$scope.data = {};

					let translateMap = {
						true: gettextCatalog.getString('bool.true'),
						false: gettextCatalog.getString('bool.false'),
					};

					$scope.getDateWithPattern = function (date) {
						return $rootScope.getDateWithPattern(date);
					};

					$scope.getHtmlIconByType = function (type, isList) {
						if (type != undefined) {
							type = type.toLowerCase();
							return $sce.trustAsHtml(getHtmlIconByType(type, isList, GrammarUtils.getTypeLabel(type)));
						}
					};

					$scope.updateGrammar = function () {
						if ($scope.qBuilderInstance) {
							var r = $scope.qBuilderInstance.getRulesForText();
							var str = new StringBuffer();
							getTextFromRule(str, r.queries, $scope.availableColumns);
							if (!$scope.selectedWidget) {
								$scope.selectedWidget = vm.datablock;
							}
							$scope.selectedWidget.rules_description = str.toString();
						}
					};

					$scope.addColumnToRules = function (col) {
						$scope.addRule($scope.qBuilderInstance, $scope.rulesRoot, col);
					};

					// If a column is not found we should return a fake one with as label column deleted to alert the user
					$scope.getColumnFromId = function (uuid) {
						let foundCol = _.find($scope.availableColumns, function(c) {
							return c.uuid === uuid;
						});
						// Return the column if found
						if (foundCol) {
							return foundCol;
						}
						// If not found, return a dummy "deleted" column object
						let deletedCols = {
							uuid: uuid,
							alias: "COL_" + uuid,
							is_list: false,
							lib:  gettextCatalog.getString('db.filter.deleted.column.label'),
							type: "string"
						};
						// Push the availableColumns list
						$scope.availableColumns.push(deletedCols);

						return deletedCols;
					};

					$scope.openSelectTopValue = function (
						rule_id,
						valueIndex,
						valueInputName
					) {
						$scope.selectedRule = getRuleById(rule_id);
						$scope.selectedValueInputName = valueInputName;
						vm.widgetData.defautValue = $scope.selectedRule.value;

						vm.widgetData.updateaction_l2 = $scope.saveTopCaracValue;
						let steps = angular.copy(vm.data.currentSteps);
						delete steps[steps.length - 1].data_operation;
						delete steps[steps.length - 1].filter;
						delete steps[steps.length - 1].agregation;
						delete steps[steps.length - 1].output;

						vm.widgetData.topCaracValueCurrentGrammar = {
							columns: vm.data.datablock.grammar.columns,
							steps: steps,
						};
						for (var c in $scope.availableColumns) {
							if (
								$scope.selectedRule.column_alias ==
								'COL_' + $scope.availableColumns[c].uuid
							) {
								vm.widgetData.topCaracValueColumn =
									$scope.availableColumns[c].uuid;
								vm.widgetData.topCaracValueColumnType =
									$scope.availableColumns[c].type;
								break;
							}
						}

						$scope.$apply();
						vm.widgetData.showTopCaracValue = true;
						$scope.$apply();
					};

					$scope.saveTopCaracValue = function (value) {
						$scope.selectedRule.value = value;
						$scope.qBuilderInstance.setRuleInputValue(
							$scope.selectedValueInputName,
							value
						);
						$scope.updateGrammar();
					};

					$scope.openSelectColumn = function (
						rule_id,
						valueIndex,
						valueInputName
					) {
						$scope.selectedRule = getRuleById(rule_id);
						$scope.selectedValueIndex = valueIndex;
						$scope.selectedValueInputName = valueInputName;
						vm.widgetData.columns = $scope.availableColumns.filter(function(col) {
																			 return !col.is_list;
																		});
						if ($scope.selectedValueIndex == 0) {
							vm.widgetData.valueColumn = $scope.selectedRule.valueColumn;
						} else {
							vm.widgetData.valueColumn = $scope.selectedRule.valueColumn2;
						}
						vm.widgetData.selectedRule = $scope.selectedRule;
						vm.widgetData.updateaction_l2 = $scope.saveSelectColumn;
						$scope.$apply();
						vm.widgetData.showValueColumnFilter = true;
						$scope.$apply();
					};

					$scope.deleteSelectedColumn = function (
						rule_id,
						valueIndex,
						valueInputName
					) {
						$scope.selectedValueIndex = valueIndex;
						$scope.selectedValueInputName = valueInputName;
						$scope.selectedRule = getRuleById(rule_id);
						if ($scope.selectedValueIndex == 0) {
							delete $scope.selectedRule.valueColumn;
						} else {
							delete $scope.selectedRule.valueColumn2;
						}
						$scope.qBuilderInstance.resetRuleInputs(
							$scope.selectedValueInputName
						);
						$scope.updateGrammar();
					};

					$scope.saveSelectColumn = function () {
						// Validation
						if (!vm.widgetData.valueColumn || !vm.widgetData.valueColumn.column) {
							$('#selectColumnModal').modal('hide');
							return;
						}
						// Update Model
						// We act on the valueColumn (Rule Model) regardless of UI state
						if ($scope.selectedValueIndex == 0) {
							$scope.selectedRule.valueColumn = vm.widgetData.valueColumn.column;
						} else {
							$scope.selectedRule.valueColumn2 = vm.widgetData.valueColumn.column;
						}
						// Clear the literal value since we are using a column
						$scope.selectedRule.value = '';
						// Prepare UI Data
						let newColLib = $scope.getColumnFromId(vm.widgetData.valueColumn.column).lib;
						let inputName = $scope.selectedValueInputName;        // e.g. rule_0_value_0
						let columnInputName = 'sc_' + inputName;              // e.g. sc_rule_0_value_0
						// Update UI
						$timeout(function() {
								// Find the actual DOM element for the column input
								var colInput = document.getElementsByName(columnInputName)[0];
								// Check its current inline display style to see if it is hidden
								var isHidden = colInput && (colInput.style.display === 'none' || colInput.style.display === '');
								if (isHidden) {
										// We call setRuleInputs which Toggles Visibility (Hide Standard -> Show Column) AND sets text.
										$scope.qBuilderInstance.setRuleInputs(inputName, newColLib);
								} else {
										// We must NOT call setRuleInputs, or it will toggle it back to Hidden.
										// We only update the value.
										$scope.qBuilderInstance.setRuleInputValue(columnInputName, newColLib);
								}
								$scope.updateGrammar();
						});

						$('#selectColumnModal').modal('hide');
					};

					$scope.openSemanticContext = function (rule_id) {
						vm.widgetData.selectedRule = getRuleById(rule_id);
						$scope.oldRuleSemanticContext = angular.copy(
							vm.widgetData.selectedRule.semantic_context
						);
						vm.widgetData.columns = $scope.selectedWidget.grammar
							? $scope.selectedWidget.grammar.columns
							: [];
						$scope.$apply();
						vm.widgetData.showSemanticContext = true;
						vm.widgetData.cancelaction_l2 = $scope.cancelSemanticContext;
						vm.widgetData.generateText = $scope.updateGrammar;
					};

					$scope.cancelSemanticContext = function () {
						vm.widgetData.selectedRule.semantic_context =
							$scope.oldRuleSemanticContext;
					};

					$scope.setRoot = function (builder, root) {
						$scope.rulesRoot = root;
						$scope.qBuilderInstance = builder;
					};

					$scope.resetColumns = function () {};

					$scope.deleteGroup = function (that, model) {
						that.deleteGroup(model);
						return;
					};

					$scope.setFilters = function (filters) {
						$scope.filters = filters;
					};

					$scope.addRule = function (that, mod, column) {
						$scope.selectedThat = that;
						$scope.selectedMod = mod;
						var model = $scope.selectedThat.addRule($scope.selectedMod);

						var selectedColumnFilter = getFilterFromColumn(
							column,
							translateMap
						);
						selectedColumnFilter.id = $scope.rule_id;
						model.id = $scope.rule_id;
						if (column.media) {
							selectedColumnFilter.is_unstructed_content = true;
						}
						$scope.selectedThat.addFilter(selectedColumnFilter);
						model.filter = selectedColumnFilter;
						model.list = selectedColumnFilter.list;
						model.path = column.path;
						model.is_unstructed_content =
							selectedColumnFilter.is_unstructed_content;
						model.parent_entite_type_id = column.parent_entite_type_id;
						model.column_alias = $scope.vm.data.refByLabel ? column.column_alias : column.alias;
						model.depot_details = column.depot_details
						$scope.nbRules++;
						model.id_ = $scope.rule_id;
						$scope.rule_id++;
					};

					$scope.resetRuleOperator = function (rule) {
						if (rule != undefined) {
							if (rule.rules == undefined || rule.rules.length == 0) {
								if (
									rule.operator != undefined &&
									rule.operator.code != undefined
								) {
									rule.operator = rule.operator.code;
								}
							} else {
								for (var r in rule.rules) {
									$scope.resetRuleOperator(rule.rules[r]);
								}
							}
						}
					};

					$scope.loadQueryBuilder = function () {
						$scope.displayJockers = false;
						if ($scope.qBuilderInstance) {
							$scope.qBuilderInstance.reset();
						}
						$scope.selectedWidget.rules_description = '';
						$scope.filters = [];
						$scope.nbRules = 0;
						$scope.rule_id = 1;

						var query_filters = [];
						// Add ALL available columns to the filter list immediately
						if ($scope.availableColumns) {
							let index = 0;
								angular.forEach($scope.availableColumns, function(col) {
								var f = getFilterFromColumn(col, translateMap);
								// If col.uuid and col.id are missing, generate one using index or alias
								if (!col.uuid && !col.id) {
										f.id = col.alias || ('filter_' + index);
								} else {
										f.id = col.uuid || col.id;
								}
								query_filters.push(f);
								index++;
							});
						}

						var query = angular.copy($scope.vm.data.filterRules);

						var rules = [];

						if (query.rules !== undefined && query.rules.length !== 0) {
							parseRules(rules, query);
						}

						for (let r in rules) {
							if ($scope.rule_id < rules[r].id_) {
								$scope.rule_id = rules[r].id_;
							}
						}

						for (let r in rules) {
							rules[r].value = parseValue(rules[r], $rootScope.getDefaultTimezone());

							let filter = getFilterFromRule(rules[r], translateMap);

							filter.is_unstructed_content =
								rules[r].is_unstructed_content ||
								rules[r].operator == 'semantic_context';
							query_filters.push(filter);

							filter.id = $scope.rule_id;
							rules[r].id = $scope.rule_id;
							$scope.rule_id++;
							$scope.nbRules++;
							if (!rules[r].id_) {
								rules[r].id_ = $scope.rule_id;
							}
						}

						if ($scope.qBuilderInstance) {
							$scope.qBuilderInstance.setFilters(query_filters);
						}

						if ($scope.qBuilderInstance) {
							$scope.qBuilderInstance.destroy();
						}
						// each component will have an id. Important if multi component  are called in the same page
						let mainInstance = 'qBuilder-' + $scope.$id;
						let instanceId = '#builder-plugins-' + $scope.$id;
						$(instanceId).queryBuilder({
							plugins: ['sortable', 'bt-tooltip-errors'],
							filters: query_filters,
							mainInstance: true,
							mainInstanceDivId: mainInstance,
							lang_code: $rootScope.currentLangCode
								? $rootScope.currentLangCode
								: 'fr',
							rootCondition: query ? query.condition : 'AND',
						});
						$(instanceId).on(
							'afterCreateRuleInput.queryBuilder',
							function (e, rule) {
								if (rule.filter.type === 'date') {
									var $input = rule.$el.find(
										'.rule-value-container input[name*=_value_]:not([name^=sc])'
									);
									$input.on('dp.change', function () {
										$input.trigger('change');
									});
									// position of date picker
									setOnClickListenerToDateInput($input);
								}
							}
						);

						if (query && query.rules && query.rules.length !== 0) {
							$(instanceId).queryBuilder('setRules', query);
						}
					};

					$scope.addGroup = function (that, mod) {
						that.addGroup(mod);
						return;
					};

					$scope.deleteRule = function (that, model) {
						$scope.nbRules--;
						that.deleteRule(model);
						$scope.updateGrammar();
					};

					$scope.openValueList = function (rule_id) {
						$scope.selectedRule = getRuleById(rule_id);
						$scope.listValue = angular.copy($scope.selectedRule.value_list);

						vm.widgetData.columns = $scope.columnsForConditions;
						vm.widgetData.listValue = $scope.listValue;
						vm.widgetData.selectedRule = $scope.selectedRule;
						vm.widgetData.updateaction_l2 = $scope.saveListValue;
						$scope.$apply();
						vm.widgetData.showListValueFilter = true;
						$scope.$apply();
					};

					$scope.saveListValue = function () {
						$scope.selectedRule.value_list = $scope.vm.widgetData.listValue;
						$scope.updateGrammar();
					};

					let getRuleById = function (id) {
						let rules = getAllShildrenRules($scope.rulesRoot.rules);

						for (let r in rules) {
							if (rules[r].id_ == id || rules[r].id == id) {
								return rules[r];
							}
						}
					};

					$scope.searchInColumns = undefined;
					$scope.filterColumnsForConditions = function () {
						if (
							$scope.searchInColumns == undefined ||
							$scope.searchInColumns == ''
						) {
							$scope.filteredColumnsForConditions = $scope.columnsForConditions;
						} else {
							$scope.filteredColumnsForConditions = _.filter(
								$scope.columnsForConditions,
								function (el) {
									return (
										el.lib
											.toLowerCase()
											.indexOf($scope.searchInColumns.toLowerCase()) > -1
									);
								}
							);
						}
					};

					vm.closeModal = function () {
						$(vm.element).modal('hide');
						vm.data.showFilter = false;

						if ($scope.qBuilderInstance) {
							$scope.qBuilderInstance.reset();
						}
						$scope.selectedWidget.rules_description = '';
					};

					$scope.deleteFilter = function () {
						vm.widgetData.showConfirmationDialog = true;
						vm.widgetData.confirmationDialogTitle = gettextCatalog.getString(
							'Confirmer la suppression'
						);
						vm.widgetData.confirmationDialogMessage = gettextCatalog.getString(
							'Tous les paramètres ici définis seront perdus. Confirmer cette action ?'
						);
						vm.widgetData.confirmationDialogActionName =
							gettextCatalog.getString('Oui');
						vm.widgetData.enableConfirmDialogAction = true;
						vm.widgetData.confirmDialogAction = function () {
							confirmDeleteFilter();
						};
					};

					let successTra = gettextCatalog.getString('Succès');
					let successSaveTra = gettextCatalog.getString(
						'Enregistrement effectué'
					);
					var confirmDeleteFilter = function () {
						vm.data.saveFilterMethod(
							{ condition: 'AND', rules: [] },
							undefined
						);
						toaster.pop('success', successSaveTra);
						vm.closeModal();
					};

					$scope.save = function () {
						var result = $scope.qBuilderInstance.getRules();
						if (result.invalid !== true) {
							resetBetweenOperator(result.queries);
							result.queries.inactive = !vm.data.filterRules.active;
							vm.data.saveFilterMethod(result.queries, $scope.limit);
							toaster.pop('success', successTra, successSaveTra);
							vm.closeModal();
						}
					};

					$scope.closeConfirmation = function () {
						vm.closeModal();
					};

					$scope.getObjectLength = function (obj) {
						return Object.keys(obj).length;
					};

					$scope.reverseComlumnsSort = function () {
						if ($scope.columnsSort == 'default') {
							$scope.columnsSort = 'up';
							$scope.columnsForConditions.sort((el1, el2) => el1.lib.localeCompare(el2.lib, undefined, { sensitivity: 'base' }));
						}
						else if ($scope.columnsSort == 'up') {
							$scope.columnsSort = 'down';
							$scope.columnsForConditions.sort((el1, el2) => el2.lib.localeCompare(el1.lib, undefined, { sensitivity: 'base' }));
						} else {
							$scope.columnsSort = 'default';
							$scope.columnsForConditions = angular.copy($scope.columnsForConditionsDefaultOrder);
						}
						$scope.filterColumnsForConditions();
					};

					function setOnClickListenerToDateInput(inputs) {
						let length = inputs.length;
						if (!length) {
							return;
						}
						for (let i = 0; i < length; i++) {
							inputs[i].addEventListener('click', function (e) {
								var datePicker = document.getElementsByClassName(
									'bootstrap-datetimepicker-widget'
								);
								if (datePicker && datePicker[0]) {
									let coordinates = inputs[i].getBoundingClientRect();
									if (coordinates) {
										let width = coordinates.width;
										for (let i = 1; i < inputs.length; i++) {
											let widthS = inputs[i].getBoundingClientRect().width;
											if (widthS) {
												width = width + widthS;
											}
										}
										datePicker[0].style = datePicker[0].style
											? datePicker[0].style
											: {};
										datePicker[0].style.position = 'fixed';
										datePicker[0].style.top = coordinates.y + 5 + 'px';
										// 30 represents margin left -right
										datePicker[0].style.left =
											coordinates.x - coordinates.width - 45 + 'px';
									}
								}
							});
						}
					}

					// Open the modal to change column value
					$scope.openChangeColumnMain = function (rule_id) {
						$scope.selectedRule = getRuleById(rule_id);
						// Get current type
						let currentType = $scope.selectedRule.filter.type;
						// Filter the available columns
						let filteredColumns = $scope.availableColumns.filter(function(col) {
							 return !col.is_list && col.type === currentType;
						});
						vm.widgetData.columns = filteredColumns;
						let currentColumnUuid = null;
						// Look for the column where the name (lib) matches the current rule label
						let foundCol = _.find(filteredColumns, function(c) {
							 return c.lib === $scope.selectedRule.filter.label;
						});
						if (foundCol) {
							 currentColumnUuid = foundCol.uuid;
						}
						// Set the modal model to the found UUID
						vm.widgetData.valueColumn = currentColumnUuid;
						//  save the rule
						vm.widgetData.selectedRule = $scope.selectedRule;
						// save
						vm.widgetData.updateaction_l2 = $scope.saveChangeColumnMain;
						// Open the cols selector
						vm.widgetData.showValueColumnFilter = true;
					};

					// Save column update
					$scope.saveChangeColumnMain = function () {
						if (!vm.widgetData.valueColumn || !vm.widgetData.valueColumn.column) {
							return;
						}
						let newColumnId = vm.widgetData.valueColumn.column;
						let newCol = $scope.getColumnFromId(newColumnId);

						if (newCol) {
							// Snapshot values before modification
							let savedValue = angular.copy($scope.selectedRule.value);
							let savedOperator = angular.copy($scope.selectedRule.operator);
							let savedValueList = angular.copy($scope.selectedRule.value_list);
							let savedValueColumn = angular.copy($scope.selectedRule.valueColumn);
							let savedValueColumn2 = angular.copy($scope.selectedRule.valueColumn2);
							// Find the EXISTING filter object in the builder's list
							// We must use the object that the builder already knows about.
							var newFilterObject = $scope.qBuilderInstance.filters.find(function(f) {
									return f.id == newCol.uuid;
							});
							// Fallback: If for some reason it's not there, create and register it
							if (!newFilterObject) {
									newFilterObject = getFilterFromColumn(newCol, translateMap);
									newFilterObject.id = newCol.uuid;
									$scope.qBuilderInstance.filters.push(newFilterObject);
							}
							// Update Rule Reference
							// CRITICAL: Point the rule to the NEW filter object.
							$scope.selectedRule.filter = newFilterObject;
							// CRITICAL: Sync the rule's internal ID with the filter ID
							// This tells the builder "This rule now belongs to this filter ID"
							$scope.selectedRule.filter.id = newCol.uuid;
							// Update Rule Metadata
							$scope.selectedRule.field = newFilterObject.label;
							$scope.selectedRule.type = newFilterObject.type;
							$scope.selectedRule.is_unstructed_content = newCol.media ? true : false;
							$scope.selectedRule.path = newCol.path;
							$scope.selectedRule.column_alias = newCol.alias;
							$scope.selectedRule.parent_entite_type_id = newCol.parent_entite_type_id;
							// Redraw HTML
							$scope.qBuilderInstance.updateRuleFilter($scope.selectedRule);
							// Restore Values (Wrapped in Timeout)
							$timeout(function() {
									// Restore Operator
									$scope.selectedRule.operator = savedOperator;
									let ruleEl = $scope.selectedRule.$el;
									let operatorSelect = ruleEl.find('.rule-operator-container [name$=_operator]');

									operatorSelect.val(savedOperator.type);
									if (operatorSelect.hasClass('selectpicker')) {
										operatorSelect.selectpicker('render');
									}

									$scope.qBuilderInstance.updateRuleOperator($scope.selectedRule, savedOperator);

									// Restore Data
									$scope.selectedRule.value = savedValue;
									$scope.selectedRule.value_list = savedValueList;
									$scope.selectedRule.valueColumn = savedValueColumn;
									$scope.selectedRule.valueColumn2 = savedValueColumn2;

									if (savedValueColumn) {
										let col = $scope.getColumnFromId(savedValueColumn);
										if (col) {
											$scope.qBuilderInstance.setRuleInputs($scope.selectedRule.input_name, col.lib);
										}
									} else if (savedValue !== undefined && savedValue !== null) {
										$scope.qBuilderInstance.setRuleValue($scope.selectedRule, savedValue);
										// Ensure model is synced
										$scope.selectedRule.value = savedValue;
									}

									$scope.updateGrammar();
							});
						}
						vm.widgetData.showValueColumnFilter = false;
					};
				},
			];

			return {
				restrict: 'E',

				scope: {
					data: '=',
					datablock: '=',
					widgetData: '=',
				},
				controller: controller,
				controllerAs: 'vm',
				bindToController: true,
				templateUrl:
					'./src/components/directives/dataOperationTools/dbFilter/dbFilter.html',
				transclude: true,
				replace: true,
				link: function postLink(scope, element, attrs) {
					$(element).modal({
						show: false,
						keyboard: attrs.keyboard,
						backdrop: attrs.backdrop,
					});
					$(element).on('hidden.bs.modal', function (event) {
						if (event.target == element[0]) {
							scope.vm.closeModal();
						}
					});
					scope.$watch(
						function () {
							return scope.vm.data.showFilter;
						},
						function (value) {
							scope.vm.element = element;
							if (value == true) {
								scope.getScopeQB = getScopeQB;
								getScopeQB = function () {
									return angular.element($('#qBuilder-' + scope.$id)).scope();
								};
								scope.limit = scope.vm.data.step
									? scope.vm.data.step.limit
									: undefined;
								scope.selectedWidget = scope.vm.datablock;
								scope.availableColumns = angular.copy(scope.vm.data.columns);
								// do not include current formula in columns
								if (scope.vm.data.currentFormulaRoot) {
									scope.availableColumns = _.filter(scope.availableColumns,
									function(col){ return !col.uuid || (col.uuid && scope.vm.data.currentFormulaRoot !== col.uuid); });
								}
								if (scope.vm.data.additionalColumns) {
									scope.availableColumns = scope.availableColumns.concat(
										scope.vm.data.additionalColumns
									);
									scope.vm.data.additionalColumns = null;
								}

								// We filter out all columns that are lists or geometry
								scope.columnsForConditions = angular.copy(
									scope.availableColumns.filter(
										(c) => !c.is_list && c.type !== 'geometry'
									)
								);
								scope.vm.data.filterRules.active =
									!scope.vm.data.filterRules.inactive;
								scope.columnsSort = 'default';
								scope.columnsForConditionsDefaultOrder = angular.copy(scope.columnsForConditions);
								if (scope.vm.data.filterTitle) {
									scope.title = scope.vm.data.filterTitle;
								} else {
									scope.title = 'Filtres';
								}
								for (var c in scope.columnsForConditions) {
									scope.columnsForConditions[c].id = c;
								}
								scope.resetRuleOperator(scope.vm.data.filterRules);

								scope.loadQueryBuilder();

								scope.updateGrammar();

								scope.filterColumnsForConditions();

								$(element).modal(
									{ backdrop: 'static', keyboard: false },
									'show'
								);
							} else {
								$(element).modal('hide');
							}
						}
					);
				},
			};
		},
	]);
})();
